<template>
  <div class="row">
    <el-container>
      <el-aside width="200px">
        <el-menu>
          <el-menu-item>
            <router-link tag="div" to="/jtzjQuery/credentialsquery1">自治区交通证件查询</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link tag="div" to="/jtzjQuery/credentialsquery2">交通部交通证件查询</router-link>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "transNews",
  data() {
    return {};
  },
  mounted() {
    this.is_route_params_null();
  },
  methods: {
    is_route_params_null() {
      if (JSON.stringify(this.$route.params) == "{}") {
        this.$router.push({
          path: "/jtzjQuery/credentialsquery1"
        });
      } else {
        if (this.$route.params.type_id == "02") {
          this.$router.push({
            path: "/jtzjQuery/credentialsquery1"
          });
        } else if (this.$route.params.type_id == "01") {
          this.$router.push({
            path: "/jtzjQuery/credentialsquery2"
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.el-container {
  height: 700px;
  width: 100%;
}
.el-aside {
  background-color: #f3f4f5;
  overflow: hidden;
  margin-right: 5px;
}
.el-menu-item {
  /* padding: 0; */
  background-color: #f3f4f5;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dashed #ccc;
}

.el-main {
  padding: 0;
}
.el-menu-item div {
  text-align: center;
  /* border:1px solid red; */
}
.router-link-active {
  color: rgba(1, 152, 251, 1);
}
</style>


// WEBPACK FOOTER //
// src/pages/jtzjquery/index.vue


// WEBPACK FOOTER //
// src/pages/jtzjquery/index.vue